import { render, staticRenderFns } from "./MobileAppView.vue?vue&type=template&id=1013b0f3&"
import script from "./MobileAppView.vue?vue&type=script&lang=js&"
export * from "./MobileAppView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports